module.exports = __webpack_public_path__ + "img/lexin.62a314f3.png";